import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ca6f2d48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-us-wrap" }
const _hoisted_2 = { class: "header-text" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"74px","color":"rgba(255,255,255,0.2)","position":"absolute","left":"40px","top":"30px"} }, " 全国统一服务热线 ", -1))
const _hoisted_4 = {
  style: {"font-size":"52px","color":"#fff","position":"absolute","left":"40px","top":"78px"},
  class: "col-b-white"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"position":"absolute","left":"40px","top":"188px"},
  class: "col-b-blue f-w-600 f-s-20"
}, " 武汉总部 ", -1))
const _hoisted_6 = {
  style: {"position":"absolute","left":"40px","top":"240px"},
  class: "col-b-white f-w-400 f-s-16"
}
const _hoisted_7 = {
  style: {"position":"absolute","left":"40px","top":"274px"},
  class: "col-b-white f-w-400 f-s-16"
}
const _hoisted_8 = { class: "p-t-40 p-b-120" }
const _hoisted_9 = { class: "contact-content flex-wrap" }
const _hoisted_10 = { class: "f-s-20 f-w-500 col-b-title m-b-24" }
const _hoisted_11 = { class: "content-text flex" }
const _hoisted_12 = { class: "left-text flex-col align-center" }
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "f-s-12 m-t-6",
  style: {"color":"#666666"}
}, "微信", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "m-l-10 m-r-10",
  style: {"border":"1px solid rgba(245,245,247,0.8)","height":"128px"}
}, null, -1))
const _hoisted_16 = { class: "right-text" }
const _hoisted_17 = { class: "col-b-content f-s-16 f-w-400" }
const _hoisted_18 = { class: "col-b-content f-s-16 f-w-400 m-t-8" }
const _hoisted_19 = { class: "col-b-content f-s-16 f-w-400 m-t-8" }
const _hoisted_20 = {
  key: 0,
  class: "col-b-content f-s-16 f-w-400 m-t-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "contact-header",
      style: _normalizeStyle({background: "url("+_ctx.bgUrl+")", backgroundSize: "100% 100%"})
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.phoneOf400), 1),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, " 电话：" + _toDisplayString(_ctx.phoneOf027), 1),
        _createElementVNode("div", _hoisted_7, " 地址：" + _toDisplayString(_ctx.address), 1)
      ])
    ], 4),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "area-info",
            key: index
          }, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(item.area_name), 1),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("img", {
                  src: item.image,
                  class: "w-100 h-100 brs4"
                }, null, 8, _hoisted_13),
                _hoisted_14
              ]),
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, "姓名：" + _toDisplayString(item.name), 1),
                _createElementVNode("div", _hoisted_18, "电话：" + _toDisplayString(item.phone), 1),
                _createElementVNode("div", _hoisted_19, "邮箱：" + _toDisplayString(item.email), 1),
                (item.address)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, "地址：" + _toDisplayString(item.address), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}